import { BaseCurrencyInput, Hairline, Radio } from "@components";
import { TimeInput } from "@components/TimeInput";
import styles from "@styles/forms-flow/creative.module.scss";
import { useEffect, useState } from "react";

export const GainReminder = ({ coupon, onChangeCreative }) => {
  const [gainReminder, setGainReminder] = useState(
    coupon?.expiration?.gain?.remind?.active
  );

  useEffect(() => {
    onChangeCreative &&
      onChangeCreative({
        ...(coupon?.expiration?.gain?.remind || {}),
        active: gainReminder,
      });
  }, [gainReminder]);

  return (
    <>
      <p className={styles.label}>Deseja ativar lembrete de expiração?</p>
      <Radio
        family="gain-reminder"
        className="mb-10"
        value={true}
        checked={gainReminder}
        onChange={() => setGainReminder(true)}
      >
        Sim
      </Radio>
      <Radio
        family="gain-reminder"
        value={false}
        checked={gainReminder}
        onChange={() => setGainReminder(false)}
      >
        Não
      </Radio>

      {gainReminder && (
        <div className={styles.reminderBox}>
          <p className={styles.label}>
            Defina o período para lembrete de expiração
          </p>
          <BaseCurrencyInput
            placeholder="--- dias antes da expiração"
            prefix={""}
            precision={0}
            suffix={" dias antes da expiração"}
            value={coupon?.expiration?.gain?.remind?.days}
            onChange={(days) => {
              onChangeCreative &&
                onChangeCreative({
                  ...(coupon?.expiration?.gain?.remind || {}),
                  days: days,
                });
            }}
          />

          <Hairline solid className="mt-20 mb-20" />

          <p className={styles.label}>Determine a hora do envio</p>
          <TimeInput
            center
            value={coupon?.expiration?.gain?.remind?.time}
            onChange={(time) => {
              onChangeCreative &&
                onChangeCreative({
                  ...(coupon?.expiration?.gain?.remind || {}),
                  time,
                });
            }}
          />
        </div>
      )}
    </>
  );
};
